import React from "react";
import styled from "styled-components";
import { MdFileDownload } from "react-icons/md";
import { BsArrowRepeat, BsThreeDotsVertical } from "react-icons/bs";

const transactions = [
  {
    id: "T001",
    ticketId: "B001",
    type: "Booking",
    icon: "🎟️",
    description: "Payment for Historical City Walk",
    name: "Alice Wonderland",
    contact: "555-0101",
    date: "Jul 15, 2024, 3:35:00 PM",
    amount: "$45.00",
    isNegative: false,
    status: "Successful",
  },
  {
    id: "T002",
    ticketId: "B002",
    type: "Booking",
    icon: "🎟️",
    description: "Payment for Zip Line Experience",
    name: "Bob The Builder",
    contact: "555-0102",
    date: "Jul 20, 2024, 8:05:00 PM",
    amount: "$75.50",
    isNegative: false,
    status: "Successful",
  },
  {
    id: "T003",
    ticketId: "O7843",
    type: "Payout",
    icon: "💵",
    description: "Settlement Payout to City Heritage Tours",
    name: "City Heritage Tours",
    contact: "123-456-7890",
    date: "Jul 5, 2024, 2:30:00 PM",
    amount: "-$1250.75",
    isNegative: true,
    status: "Successful",
  },
  {
    id: "T004",
    ticketId: "B8235",
    type: "Registration Fee",
    icon: "🧾",
    description: "Partner Registration Fee",
    name: "ThrillSeeker Adventures",
    contact: "234-567-8901",
    date: "Mar 22, 2024, 3:30:00 PM",
    amount: "$50.00",
    isNegative: false,
    status: "Successful",
  },
  {
    id: "T005",
    ticketId: "B9102",
    type: "Subscription",
    icon: "💳",
    description: "Monthly Platform Subscription - July",
    name: "Aqua Fun Waterpark",
    contact: "567-890-1234",
    date: "Jul 1, 2024, 5:30:00 AM",
    amount: "$29.99",
    isNegative: false,
    status: "Successful",
  },
];

const TransactionSuper = () => {
  return (
    <Wrapper>
      <div className="container py-5">
        <div className="card border-0 shadow-sm p-4">
          <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
              <div>
                <h4 className="text-dark mb-1 d-flex align-items-center">Transaction History</h4>
                <p className="text-muted mb-0">
                  Overall transaction activities across different partners
                </p>
              </div>
              <div className="mt-2 mt-md-0">
                <button className="btn btn-primary d-flex align-items-center">
                  <MdFileDownload className="me-2" size={20} />
                  Export Transaction
                </button>
              </div>
            </div>

            <div className="container my-4 p-0">
              <div className="d-flex align-items-center flex-nowrap gap-2 mb-3 filter-box">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search ID, Customer, Service"
                />
                <select className="form-select">
                  <option>All Types</option>
                    {/* <option>All Types</option> */}
                  <option>Booking</option>
                  <option>Registration Fee</option>
                </select>
                <select className="form-select">
                  <option>All Time</option>
                </select>
                <select className="form-select">
                  <option>All Statuses</option>
                </select>
                <button className="btn btn-outline-secondary d-flex align-items-center gap-1">
                  <BsArrowRepeat size={16} />
                  Clear Filters
                </button>
              </div>

              <table className="table table-bordered align-middle">
                <thead>
                  <tr>
                    <th>Ticket/Partner ID</th>
                    <th>Transaction ID</th>
                    <th>Transaction Type</th>
                    <th>Description</th>
                    <th>User/Partner Name</th>
                    <th>Transaction Date & Time</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((tx, idx) => (
                    <tr key={idx}>
                      <td>{tx.ticketId}</td>
                      <td className="text-primary fw-semibold">{tx.id}</td>
                      <td>
                        <span className={`badge badge-type ${tx.type.toLowerCase().replace(/\s/g, '-')}`}>
                          {/* {tx.icon} */}
                           {tx.type}
                        </span>
                      </td>
                      <td>{tx.description}</td>
                      <td>
                        {tx.name}
                        <br />
                        <small className="text-muted">{tx.contact}</small>
                      </td>
                      <td>{tx.date}</td>
                      <td className={tx.isNegative ? "text-danger fw-semibold" : "text-success fw-semibold"}>
                        {tx.amount} <span className="text-muted">USD</span>
                      </td>
                      <td>
                        <span className="badge bg-success bg-opacity-25 text-success px-2 py-1 rounded-pill">
                          {tx.status}
                        </span>
                      </td>
                      <td>
                        <BsThreeDotsVertical />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default TransactionSuper;

const Wrapper = styled.div`
  .filter-box input,
  .filter-box select {
    width: 169px;
  }

  .badge-type {
    font-size: 0.85rem;
    padding: 6px 12px;
    border-radius: 50px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .badge-type.booking {
    background-color: rgba(13, 110, 253, 0.15); /* blue */
    color: #0d6efd;
  }

  .badge-type.payout {
    background-color: rgba(255, 193, 7, 0.15); /* yellow */
    color: #ffc107;
  }

  .badge-type.registration-fee {
    background-color: rgba(25, 135, 84, 0.15); /* green */
    color: #198754;
  }

  .badge-type.subscription {
    background-color: rgba(111, 66, 193, 0.15); /* purple */
    color: #6f42c1;
  }

  .table thead th {
    background-color: #f8f9fa;
  }
`;
